import axios from 'axios'
import router from '../router/index';
import common from './common';

axios.defaults.crossDomain = true
axios.defaults.withCredentials = false
// post请求头
// axios.defaults.headers.common['Content-Type'] = 'application/json;charset=utf-8'

axios.defaults.headers.common['Content-Type'] = 'multipart/form-data'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

// 请求超时时间
// axios.defaults.timeout = 30000;
// axios.defaults.baseURL = process.env.VUE_APP_API_URL + '/api';
// axios.defaults.baseURL = "/api";

axios.defaults.baseURL = process.env.VUE_APP_BASE_API

const appid = "wx01a89608b1816970"
const voiceAppid = "wxa93f72aa35f0d92d"
let authInvalidHandled = false

function clearAuthInfo() {
    localStorage.removeItem('token')
    localStorage.removeItem('expires')
    localStorage.removeItem('username')
    localStorage.removeItem('user_id')
    common.clearAuthCookies()
}

function handleAuthInvalid() {
    if (authInvalidHandled) return
    authInvalidHandled = true
    clearAuthInfo()

    if (router.app && router.app.$root) {
        router.app.$root.$emit('auth-invalid')
        router.app.$root.$emit('show-login')
    }

    setTimeout(() => {
        authInvalidHandled = false
    }, 1000)
}

// 请求拦截器
axios.interceptors.request.use(
    config => {
        let token = localStorage.getItem('token') || common.getCookie('juima_access_token');
        // let expires = localStorage.getItem("expires") || 0;
        // const query = router.currentRoute.query;
        // let token_info = '';
        // let expires_info = 0;
        // if (query.access_token) {
        //     token_info = query.access_token;
        //     if (query.access_token_exp) {
        //         expires_info = query.access_token_exp * 1
        //     }
        // }
        // if (expires <= expires_info) {
        //     token = token_info;
        //     localStorage.setItem("token", token_info);
        //     localStorage.setItem("expires", expires_info);
        // }
        // console.log(token)
        if (token) {
            config.headers.Authorization = 'Bearer ' + token
        }
        return config
    },
    error => {
        return Promise.reject(error)
    })

// 响应拦截器
axios.interceptors.response.use(
    response => {
        const code = Number(response.data && response.data.code)
        if (code === 401 || code === 403) {
            handleAuthInvalid()
        }
        return Promise.resolve(response)
    },
    error => {
        const status = error && error.response && error.response.status
        if (status === 401 || status === 403) {
            handleAuthInvalid()
        }
        return Promise.reject(error)
    }
)

function get(url, params) {
    return new Promise((resolve, reject) => {
        let paramsData = {
            ...params,
            platform_source_from: 1
        }

        if (url == "/console/initRoom" || url == "/index/Gt/dogtJson" || url == '/user/sendSmsCode') {
            delete paramsData.platform_source_from
        }
        if(url == '/user/loginVerify'){
            paramsData.platform_source_from = 15
        }


        axios.get(url, { ...paramsData }).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * post方法，对应post请求
 * @param  url 请求的url地址
 * @param  params 请求时携带的参数
 **/
function post(url, params) {
    return new Promise((resolve, reject) => {
        let paramsData = {
            ...params,
            platform_source_from: 1
        }

        if (url == "/console/initRoom" || url == "/index/Gt/dogtJson" || url == '/user/sendSmsCode' || url == '/console/userGroup/memberPointsList' || url == "/console/voiceCloneList") {
            delete paramsData.platform_source_from
        }
        if(url == '/user/loginVerify'){
            paramsData.platform_source_from = 15
        }
        axios.post(url, { ...paramsData }).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err)
        })
    })
}




export default {
    appid,
    voiceAppid,
    get,
    post
}
